<template>
  <div>
    <v-navigation-drawer
      v-model="drawer"
      enable-resize-watcher
      fixed
      app
      class="grey darken-4"
    >
      <side-drawer></side-drawer>
    </v-navigation-drawer>
    <v-toolbar
      app
      color="primary"
      class="elevation-1"
    >
      <v-btn icon @click="goBack()">
        <v-icon>keyboard_arrow_left</v-icon>
      </v-btn>
      <v-spacer></v-spacer>
      <v-toolbar-title class="white--text"><span v-if="voucherType">{{ voucherType.name }}</span></v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn icon @click="refreshList()" class="white--text">
        <v-icon>autorenew</v-icon>
      </v-btn>
      <v-btn icon @click.stop="rightDrawer = !rightDrawer" class="white--text">
        <v-icon>filter_list</v-icon>
      </v-btn>
    </v-toolbar>
    <v-navigation-drawer
      temporary
      right
      v-model="rightDrawer"
      fixed
      app
      :width=500
    >
      <v-container grid-list-md>
        <v-layout row wrap>
          <v-flex
            xs12
            text-xs-center
            layout
            align-center
            justify-center
            class="pl-4 pr-4"
          >
            <v-form ref="form" v-model="frmValid" @submit.prevent="">
              <v-text-field
                v-model="txtVoucherCode"
                label="Voucher Code"
                @keyup.enter="items=[]; getVoucherCodes(txtVoucherCode, txtReferenceNo, txtSearchRemarks, cboSort); rightDrawer=false;"
              ></v-text-field>
              <v-text-field
                v-model="txtReferenceNo"
                label="Reference No"
                @keyup.enter="items=[]; getVoucherCodes(txtVoucherCode, txtReferenceNo, txtSearchRemarks, cboSort); rightDrawer=false;"
              ></v-text-field>
              <v-text-field
                v-model="txtSearchRemarks"
                label="Remarks"
                @keyup.enter="items=[]; getVoucherCodes(txtVoucherCode, txtReferenceNo, txtSearchRemarks, cboSort); rightDrawer=false;"
              ></v-text-field>
              <v-select
                v-model="cboSort"
                :items="sorts"
                item-text="caption"
                item-value="value"
                label="Sorting"
              ></v-select>
              <v-btn
                :disabled="!frmValid"
                @click="items=[]; getVoucherCodes(txtVoucherCode, txtReferenceNo, txtSearchRemarks, cboSort); rightDrawer=false;"
              >
                Filter
              </v-btn>
              <v-btn @click="clearFilter">Reset</v-btn>
            </v-form>
          </v-flex>
        </v-layout>
      </v-container>
    </v-navigation-drawer>
    <v-content>
      <v-list two-line fill-height>
        <template
          v-for="(item, index) in items"
        >
          <v-list-tile
            :key="item.voucherCode"
            avatar
            ripple
            :class="(index % 2 === 0 ? 'row1' : 'row2')"
          >
            <v-list-tile-action>
              <v-list-tile-action-text>
                <div class="subheading">{{ item.usageCount + '/' + item.maxUsageLimit }}</div>
              </v-list-tile-action-text>
            </v-list-tile-action>

            <v-list-tile-content>
              <v-list-tile-title>
                <span class="mr-3">{{ item.voucherCode }}</span>
                <span v-if="item.isVoucherExpired === '1'" class="caption red--text">[EXPIRED]</span>
                <span v-else-if="item.usageCount >= item.maxUsageLimit" class="caption orange--text">[USED-UP]</span>
                <span v-else class="caption grey--text">[Expires {{ item.expiryDateTimeDisplay }}]</span>
                <v-icon small class="ml-3 red--text" v-if="item.isPublic === '1'" title="Visible publicly">visibility_on</v-icon>
              </v-list-tile-title>
              <v-list-tile-sub-title class="caption">
                <div>Ref: {{ item.referenceNo }}<span v-if="item.remarks.length > 0" class="ml-3">Remarks: {{ item.remarks }}</span></div>
                <div>Created by {{ item.createdByAdminName }} ({{ item.createdDateTimeDisplay }})</div>
              </v-list-tile-sub-title>
            </v-list-tile-content>

            <v-list-tile-action>
              <v-list-tile-action-text class="text-xs-right">
                <v-btn outline small class="pl-3 pr-3 caption" @click="downloadVoucherPdf(item.voucherCode)">
                  Voucher PDF
                </v-btn>
                <v-btn outline small class="ml-2 pl-3 pr-3 caption" :to="'/orders/all?voucher=' + item.voucherCode">
                  View Orders
                </v-btn>
              </v-list-tile-action-text>
            </v-list-tile-action>

          </v-list-tile>
          <v-divider
            v-if="index + 1 < items.length"
            :key="index"
          ></v-divider>
        </template>
        <template
          v-if="items.length <= 0"
        >
          <v-flex
            xs12
            justify-center
            align-center
            text-xs-center
          >
            <v-icon x-large color="primary">error_outline</v-icon>
            <div>
              No voucher code yet
            </div>
          </v-flex>
        </template>
      </v-list>
      <v-fab-transition>
        <v-btn
          color=primary
          dark
          fab
          fixed
          bottom
          right
          class="mr-2"
          @click="showGenerateCodeDialog"
        >
          <v-icon>add</v-icon>
        </v-btn>
      </v-fab-transition>

      <v-container fluid grid-list-xs class="mt-3 mb-0">
        <v-layout row wrap>
          <v-flex xs12 class="text-xs-center">
            <div class="mb-3">
              Showing {{ listCountFrom }} - {{ listCountTo }} of {{ listTotal }} orders
            </div>
          </v-flex>
          <v-flex xs12 class="text-xs-center hidden-sm-and-up">
            <v-pagination
              v-model="pageNo"
              :length="(pageCount ? pageCount : 0)"
              :total-visible="5"
              circle
            ></v-pagination>
          </v-flex>
          <v-flex xs12 class="text-xs-center hidden-xs-only">
            <v-pagination
              v-model="pageNo"
              :length="(pageCount ? pageCount : 0)"
              :total-visible="12"
              circle
            ></v-pagination>
          </v-flex>
        </v-layout>
      </v-container>

      <v-dialog v-model="dialogGenerateCode" max-width="500">
        <v-card>
          <v-card-title class="headline">
            Generate voucher code
          </v-card-title>
          <v-card-text>
            <v-form ref="formGenerateCode" v-model="frmGenerateCodeValid" @submit.prevent="">
              <v-text-field
                label="Number of voucher"
                v-model="txtVoucherCount"
                :rules="[v => v > 0 || 'Should be > 0', v => v <= 100 || 'Should be 100 or below', v => /^[-|+]?\d*$/.test(v) || 'Must be integer']"
                @keyup.enter="generateCode(txtVoucherCount, txtExpiryInDays, txtMaxUsageLimit, txtRemarks)"
                type="number"
              ></v-text-field>
              <v-text-field
                label="Expiry in days"
                v-model="txtExpiryInDays"
                :rules="[v => v > 0 || 'Should be > 0', v => v <= 365 || 'Should be 365 or below', v => /^[-|+]?\d*$/.test(v) || 'Must be integer']"
                @keyup.enter="generateCode(txtVoucherCount, txtExpiryInDays, txtMaxUsageLimit, txtRemarks)"
                type="number"
              ></v-text-field>
              <v-text-field
                label="Max Usage Limit"
                v-model="txtMaxUsageLimit"
                :rules="[v => v > 0 || 'Should be > 0', v => v <= 100 || 'Should be 100 or below', v => /^[-|+]?\d*$/.test(v) || 'Must be integer']"
                @keyup.enter="generateCode(txtVoucherCount, txtExpiryInDays, txtMaxUsageLimit, txtRemarks)"
                type="number"
              ></v-text-field>
              <v-text-field
                label="Remarks"
                v-model="txtRemarks"
                @keyup.enter="generateCode(txtVoucherCount, txtExpiryInDays, txtMaxUsageLimit, txtRemarks)"
              ></v-text-field>
              <v-btn
                large
                block
                color="primary"
                :disabled="!frmGenerateCodeValid"
                @click="generateCode(txtVoucherCount, txtExpiryInDays, txtMaxUsageLimit, txtRemarks)"
              >
                Generate
              </v-btn>
            </v-form>
          </v-card-text>
        </v-card>
      </v-dialog>
      <v-dialog
        v-model="loading"
        hide-overlay
        persistent
        width="220"
      >
        <loading></loading>
      </v-dialog>
    </v-content>
  </div>
</template>

<script>
import SideDrawer from '@/components/SideDrawer.vue'
import Loading from '@/components/Loading.vue'
import axios from 'axios'
import router from '../router'
import moment from 'moment'
import downloadjs from 'downloadjs'

export default {
  props: [
    'voucherTypeId'
  ],
  components: {
    SideDrawer,
    Loading
  },
  data () {
    return {
      drawer: false,
      rightDrawer: false,
      loading: false,
      voucherType: {},
      frmValid: true,
      txtVoucherCode: '',
      txtReferenceNo: '',
      txtSearchRemarks: '',
      cboSort: null,
      sorts: [
        {
          caption: 'Latest',
          value: 'createdDateTime:desc'
        },
        {
          caption: 'Earliest',
          value: 'createdDateTime:asc'
        },
        {
          caption: 'Max Usage count',
          value: 'usageCount:desc'
        },
        {
          caption: 'Min Usage count',
          value: 'usageCount:asc'
        }
      ],
      items: [],
      listLimit: 10,
      listOffset: 0,
      listTotal: 0,
      listCountFrom: 0,
      listCountTo: this.listLimit,
      pageNo: parseInt(this.$route.query.pg) || 1,
      pageCount: 0,
      dialogGenerateCode: false,
      frmGenerateCodeValid: false,
      txtGenerateCode: '',
      txtVoucherCount: 0,
      txtExpiryInDays: 1,
      txtMaxUsageLimit: 1,
      txtRemarks: ''
    }
  },

  mounted () {
    this.openDrawerForDesktop()
    this.getVoucherType(this.voucherTypeId)
    this.getVoucherCodes()
    // this.detectBottomOfWindow()
  },

  watch: {
    pageNo (val, oldVal) {
      // If page no changes, navigate to new page
      this.getVoucherCodes(this.txtVoucherCode, this.txtReferenceNo, this.txtSearchRemarks, this.cboSort, (val - 1) * this.listLimit)
    }
  },

  methods: {
    downloadVoucherPdf: function (voucherCode) {
      var _this = this
      _this.loading = true
      axios.get(process.env.VUE_APP_API_ROOT + '/v1/voucher/code/' + voucherCode + '/pdf', {
        responseType: 'blob'
      })
        .then(resp => {
          downloadjs(resp.data, 'Voucher-' + voucherCode + '.pdf', resp.headers['content-type'])
          _this.loading = false
        })
        .catch(err => {
          if (err.response) {
            console.log('Failed to get voucher PDF: ' + err.response.status)
            if (err.response.status === 401) {
              router.push('/login?next=' + _this.$route.fullPath)
            }
            _this.loading = false
          }
        })
    },
    showGenerateCodeDialog: function () {
      this.txtGenerateCode = ''
      this.txtVoucherCount = 1
      this.txtExpiryInDays = this.voucherType.expiryInDays
      this.txtMaxUsageLimit = this.voucherType.maxUsageLimit
      this.txtRemarks = ''
      this.dialogGenerateCode = true
    },
    generateCode: function (txtVoucherCount, txtExpiryInDays, txtMaxUsageLimit, txtRemarks) {
      var _this = this
      if (_this.$refs.form.validate()) {
        var data = {
          count: txtVoucherCount,
          expiryInDays: txtExpiryInDays,
          maxUsageLimit: txtMaxUsageLimit,
          remarks: txtRemarks
        }

        _this.loading = true
        axios.post(process.env.VUE_APP_API_ROOT + '/v1/voucher/' + _this.voucherTypeId + '/code', data, {
          headers: {
            'Content-Type': 'application/json'
          }
        })
          .then(resp => {
            _this.loading = false
            console.log(resp.data)
            if (resp.data.status === 'success') {
              _this.dialogGenerateCode = false
              _this.clearFilter()
            } else {
              window.alert(resp.data.message)
            }
          })
          .catch(function (error) {
            if (error.response) {
              console.log(error.response.status)
              if (error.response.status === 401) {
                router.push('/login?next=' + _this.$route.fullPath)
              } else if (error.response.status === 403) {
                _this.showAlert(error)
              }
              _this.loading = false
            }
          })
      }
    },
    getVoucherType: function (voucherTypeId) {
      if (voucherTypeId) {
        this.loading = true
        axios.get(process.env.VUE_APP_API_ROOT + '/v1/voucher/' + voucherTypeId)
          .then(resp => {
            this.loading = false
            console.log(resp.data)
            if (resp.data.status === 'success') {
              this.voucherType = resp.data.data
            } else {
              console.log('unable to load voucher type details: ' + resp.data.message)
            }
          })
          .catch(function (error) {
            if (error.response) {
              console.log(error.response.status)
              if (error.response.status === 401) {
                router.push('/login?next=' + this.$route.fullPath)
              } else if (error.response.status === 403) {
                this.showAlert(error)
              }
              this.loading = false
            }
          })
      }
    },
    refreshList: function () {
      this.items = []
      var _this = this
      return new Promise(function (resolve, reject) {
        var promise = _this.getVoucherCodes(_this.txtVoucherCode, _this.txtReferenceNo, _this.txtSearchRemarks, _this.cboSort, 0)
        promise.then(function () {
          resolve()
        })
      })
    },
    detectBottomOfWindow: function () {
      window.onscroll = () => {
        // console.log(document.documentElement.scrollTop + window.innerHeight) - 48;
        // console.log(document.documentElement.offsetHeight);
        let bottomOfWindow = document.documentElement.scrollTop + window.innerHeight === document.documentElement.offsetHeight

        if (bottomOfWindow) {
          if (this.listTotal > this.items.length) {
            this.getVoucherCodes(this.txtVoucherCode, this.txtReferenceNo, this.txtSearchRemarks, this.cboSort, this.items.length)
          }
        }
      }
    },
    getVoucherCodes: function (code = '', ref = '', remarks = '', sort = '', offset = 0) {
      var _this = this
      var promise = new Promise(function (resolve, reject) {
        _this.loading = true
        axios.get(process.env.VUE_APP_API_ROOT + '/v1/voucher/' + _this.voucherTypeId + '/codes?code=' + code + '&reference_no=' + ref + '&remarks=' + remarks + '&sort=' + sort + '&limit=' + _this.listLimit + '&offset=' + offset)
          .then(resp => {
            _this.loading = false
            console.log(resp.data)
            if (resp.data.status === 'success') {
              for (var c = 0; c < resp.data.data.length; ++c) {
                resp.data.data[c].createdDateTimeDisplay = moment(resp.data.data[c].createdDateTime, _this.iso8601Format()).fromNow()
                resp.data.data[c].expiryDateTimeDisplay = moment(resp.data.data[c].expiryDateTime, _this.iso8601Format()).fromNow()
              }
              _this.items = resp.data.data
              _this.listLimit = resp.data.limit
              _this.listOffset = resp.data.offset
              _this.listTotal = resp.data.total
              _this.pageCount = Math.ceil(_this.listTotal / _this.listLimit)
              _this.listCountFrom = _this.listOffset + 1
              _this.listCountTo = (_this.listCountFrom - 1) + _this.items.length
              if (_this.items.length === 0) {
                _this.listCountFrom = 0
                _this.listCountTo = 0
              }
            } else {
              console.log('unable to load voucher codes: ' + resp.data.message)
            }
            resolve()
          })
          .catch(function (error) {
            if (error.response) {
              console.log(error.response.status)
              if (error.response.status === 401) {
                router.push('/login?next=' + _this.$route.fullPath)
                reject(error.response.status)
              } else if (error.response.status === 403) {
                _this.showAlert(error)
                reject(error.response.status)
              }
              _this.loading = false
            }
          })
      })
      return promise
    },
    clearFilter () {
      this.$refs.form.reset()
      this.items = []
      this.getVoucherCodes(this.txtVoucherCode, this.txtReferenceNo, this.txtSearchRemarks, this.cboSort)
      this.rightDrawer = false
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.tabs__slider {
  height: 3px;
}

form {
  width: 100%;
}

</style>
